import { render } from "./IconNormalFolderOpen.vue?vue&type=template&id=bca8d864"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconNormalFolderOpen.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bca8d864"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bca8d864', __exports__)) {
    api.reload('bca8d864', __exports__)
  }
  
  module.hot.accept("./IconNormalFolderOpen.vue?vue&type=template&id=bca8d864", () => {
    api.rerender('bca8d864', render)
  })

}


export default __exports__